import dayjs from 'dayjs';
import marked from 'marked';

var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime);
var updateLocale = require('dayjs/plugin/updateLocale')
dayjs.extend(updateLocale)

dayjs.updateLocale('en', {
  relativeTime: {
    future: "%s後",
    past: "%s前",
    s: '数秒',
    m: "1分",
    mm: "%d分",
    h: "1時間",
    hh: "%d時間",
    d: "1日",
    dd: "%d日",
    M: "1ヶ月",
    MM: "%d花月",
    y: "1年",
    yy: "%d年"
  }
});


const utils = {
  isFirst: true,
  // アニメーション対象監視
  observeAnimationElement(root, query = '[data-reveal-class]') {
    var elements = root.querySelectorAll(query);
    var observer = new IntersectionObserver((entries, observer) => {
      // 監視対象で変化があったものすべてが entries に入ってくる
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          var target = entry.target;
          target.classList.add(target.dataset.revealClass);
        }
      });
    }, {
      threshold: 0.3
    });

    Array.from(elements).forEach($elm => {
      observer.observe($elm);
    });
  },
  async contact(data) {
    try {
      var res = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      });
      return res;
    }
    catch (error) {
      throw error;
    }
  },

};

export default utils;
